export default "__VITE_ASSET__44a1ffaa__"